import React from "react"
import { Link } from 'react-router-dom'
import Chronometer from 'app/components/Chronometer'

export default ({ prefix, dodone }) => {
  return <Link to={ `/dodones/${dodone.id}` } className={ `dodone-list-item dodone-list-item-${dodone.status}` }>
           <div className="dodone-list-item-content">
             { prefix ? <div className="dodone-list-item-content-prefix"> { prefix } </div> : null }
             <div className="dodone-list-item-text"> { dodone.dodoable.name } </div>
             { dodone.isOngoing ? <Chronometer startedAt={ dodone.startedAt } size={ 'extra-small' } /> : null }
           </div>
           <div className='dodone-list-item-icon-wrapper'>
             <i className="dodone-list-item-icon"></i>
           </div>
         </Link>
}
